// extracted by mini-css-extract-plugin
export default {"popupWrapper":"contextMenu_popupWrapper__h1JBl","itemDisabled":"contextMenu_itemDisabled__vc6PD"};